// Coordonnées utilisateur - stockées UNIQUEMENT dans le navigateur (localStorage)
// Aucun envoi vers le serveur - conforme RGPD

const KEY = "lexa_user_profile_v1";

const EMPTY = {
  civilite: "",
  prenom: "",
  nom: "",
  adresse: "",
  codePostal: "",
  ville: "",
  telephone: "",
  email: "",
};

export function getProfile() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...EMPTY };
    return { ...EMPTY, ...JSON.parse(raw) };
  } catch {
    return { ...EMPTY };
  }
}

export function saveProfile(profile) {
  const clean = { ...EMPTY, ...profile };
  localStorage.setItem(KEY, JSON.stringify(clean));
  return clean;
}

export function clearProfile() {
  localStorage.removeItem(KEY);
}

export function isProfileComplete(p = getProfile()) {
  return Boolean(
    p.prenom.trim() &&
    p.nom.trim() &&
    p.adresse.trim() &&
    p.codePostal.trim() &&
    p.ville.trim()
  );
}

// Construit un bloc texte à injecter dans la requête envoyée à l'IA
// afin qu'elle utilise directement les coordonnées, sans crochets.
export function buildProfilePrefix(p = getProfile()) {
  if (!isProfileComplete(p)) return "";
  const fullName = [p.civilite, p.prenom, p.nom].filter(Boolean).join(" ").trim();
  const contact = [p.telephone, p.email].filter(Boolean).join(" — ");
  return (
    "Coordonnées de l'expéditeur (à utiliser telles quelles, sans crochets, sans « [Votre... » ni « [Nom Prénom ]») :\n" +
    `- Nom complet : ${fullName}\n` +
    `- Adresse : ${p.adresse}\n` +
    `- Code postal et ville : ${p.codePostal} ${p.ville}\n` +
    (contact ? `- Contact : ${contact}\n` : "")
  );
}
